export const ping = () => ({
    url: 'tests/ping',
    method: 'get',
});